<gp-modal gp-modal="edit-event"
          test-id="taModal"
          [closable]="true"
          [onSubmit]="submitCallback"
          #eventpopup>
  <div class="gp-modal-title">
    {{ getTitleModal() }}
  </div>
  <div class="gp-modal-body">
    <form novalidate *ngIf="currentEvent" [formGroup]="eventForm">
      <div class="form-group">
        <label>{{ 'COMMON.category' | translate }}</label>
        <ng-select class="form-control"
                   name="familyType"
                   formControlName="familyType"
                   [(ngModel)]="currentEvent.familyTransId"
                   (ngModelChange)="onChangeCategoryEvent($event)"
                   [idField]="'id'"
                   [textField]="'transId'"
                   [items]="categorySelectList"
                   [readOnly]="preview"
                   [disabled]="false"
        >
        </ng-select>

      </div>
      <div class="form-group">
        <label>{{ 'PAYROLL_PREPARE.event_type' | translate }}</label>
        <ng-select class="form-control"
                   name="type"
                   formControlName="type"
                   required
                   [(ngModel)]="currentEvent.attributes.type"
                   (ngModelChange)="onChangeTypeEvent($event)"
                   [idField]="'name'"
                   [textField]="'transId'"
                   [items]="eventForm.get('familyType')?.value
                    ? this.types[eventForm.get('familyType').value]
                    : eventTypes"
                   [readOnly]="preview"
                   [disabled]="isAccrualEstimating(currentEvent) || isAccrualPrepareEstimation(currentEvent) || preview"
        >
        </ng-select>
      </div>

      <div class="row" *ngIf="currentEvent.attributes.type">
        <div class="col-md-6">
          <div class="form-group">
            <label>{{ 'FORMS.begin_date' | translate }}</label>
            <datepicker-input #begindate
                              name="begindate"
                              test-id="beginDateModal"
                              [(ngModel)]="currentEvent.attributes.begin"
                              [minDate]="minDate"
                              [maxDate]="maxDate"
                              [hasEternity]="true"
                              (ngModelChange)="onChangeDates()"
                              formControlName="beginDate"
                              [readOnly]="preview"
                              [disabled]="isAccrualEstimating(currentEvent) || isAccrualPrepareEstimation(currentEvent)">
            </datepicker-input>
          </div>
        </div>
        <div class="col-md-2"></div>
        <div class="col-md-6">
          <div class="form-group">
            <label>{{ 'FORMS.end_date' | translate }}</label>
            <datepicker-input #enddate
                              name="enddate"
                              test-id="endDateModal"
                              [(ngModel)]="currentEvent.attributes.end"
                              [minDate]="minDate"
                              [maxDate]="maxDate"
                              [hasEternity]="true"
                              (ngModelChange)="onChangeDates()"
                              formControlName="endDate"
                              [readOnly]="preview"
                              [disabled]="isAccrualEstimating(currentEvent) || isAccrualPrepareEstimation(currentEvent)">
            </datepicker-input>
          </div>
        </div>
      </div>
      <ul class="error-list begin-before-end" *ngIf="!isBeginBeforeEnd && eventForm.valid && getDatePickerValid()">
        <li>{{'FORMS.VALIDATORS.end_date_earlier_start_date' | translate}}</li>
      </ul>
      <div class="row" style="margin-bottom: 1rem;"
           *ngIf="currentEvent.parentType === 'repAbsence' && !isSingleDay(currentEvent)">
        <div class="col-md-6">
          <div class="form-group">
            <div>{{ 'PAYROLL_PREPARE.begin_date_duration' | translate }}:</div>
            {{ 'PAYROLL_PREPARE.duration' | translate }}:
            <number-input #beginRangeHour
                          [type]="'integer'"
                          [(ngModel)]="timeFields.beginDateRange.hours"
                          [classes]="['time-input']"
                          formControlName="beginHours"
                          (blur)="checkDateRange('beginDateRange', 'begin')"
                          (keyup)="setDateRange('beginDateRange',
                          beginRangeHour.input.nativeElement.value,
                          beginRangeMinute.input.nativeElement.value,
                          'begin',
                          true)"
                          [readOnly]="preview || isEmptyRange('begin') || isFullDayAllowed() || isHalfDayAllowed()"
                          [disabled]="isAccrualEstimating(currentEvent) || isAccrualPrepareEstimation(currentEvent)">
            </number-input>
            {{'PAYROLL_PREPARE.h' | translate}}
            <number-input #beginRangeMinute
                          [type]="'integer'"
                          [(ngModel)]="timeFields.beginDateRange.minutes"
                          [classes]="['time-input']"
                          formControlName="beginMinutes"
                          (blur)="checkDateRange('beginDateRange', 'begin')"
                          (keyup)="setDateRange('beginDateRange',
                          beginRangeHour.input.nativeElement.value,
                          beginRangeMinute.input.nativeElement.value,
                          'begin',
                          true)"
                          [readOnly]="preview || isEmptyRange('begin') || isFullDayAllowed() || isHalfDayAllowed()"
                          [disabled]="isAccrualEstimating(currentEvent) || isAccrualPrepareEstimation(currentEvent)">
            </number-input>
            {{'PAYROLL_PREPARE.m' | translate}}
            {{ getRangeDurationLabel(currentEvent.beginDateRange, 'begin')}}
            <div class="time-of-day" *ngIf="!preview && !isSliderLoaded">
              <div class="day-buttons" [ngClass]="{'greyed-out': isFullDayAllowed() || isEmptyRange('begin')}">
                <button class="btn buttons-xs p-x-xs btn-day-part"
                        [ngClass]="{
                        'btn-day-part-active': isMorning('beginDateRange'),
                        'greyed-out': isFullDayAllowed() || isEmptyRange('begin')}"
                        [disabled]="isFullDayAllowed() || isEmptyRange('begin') || isAccrualEstimating(currentEvent) || isAccrualPrepareEstimation(currentEvent)"
                        (click)="setMorning('beginDateRange')">
                  {{'TIME_AND_ATTENDANCE.morning' | translate}}
                </button>
                <button class="btn buttons-xs p-x-xs btn-day-part"
                        [ngClass]="{
                        'btn-day-part-active': isAfternoon('beginDateRange'),
                        'greyed-out': isFullDayAllowed() || isEmptyRange('begin')}"
                        [disabled]="isFullDayAllowed() || isHalfDayAllowed() || isAfternoonDisabled('beginDateRange')
                        || isEmptyRange('begin') || isAccrualEstimating(currentEvent) || isAccrualPrepareEstimation(currentEvent)"
                        (click)="setAfternoon('beginDateRange')">
                  {{'TIME_AND_ATTENDANCE.afternoon' | translate}}
                </button>
              </div>
            </div>
            <!--[step]="0.25"-->
          </div>
        </div>
        <div class="col-md-2"></div>
        <div class="col-md-6">
          <div class="form-group">
            <div>{{ 'PAYROLL_PREPARE.end_date_duration' | translate }}:</div>
            {{ 'PAYROLL_PREPARE.duration' | translate }}:
            <number-input #endRangeHour
                          [type]="'integer'"
                          [(ngModel)]="timeFields.endDateRange.hours"
                          [classes]="['time-input']"
                          formControlName="endHours"
                          (blur)="checkDateRange('endDateRange', 'end')"
                          (keyup)="setDateRange('endDateRange',
                          endRangeHour.input.nativeElement.value,
                          endRangeMinute.input.nativeElement.value,
                          'end')"
                          [readOnly]="preview || isEmptyRange('end') || isFullDayAllowed() || isHalfDayAllowed()"
                          [disabled]="isAccrualEstimating(currentEvent) || isAccrualPrepareEstimation(currentEvent)">
            </number-input>
            {{'PAYROLL_PREPARE.h' | translate}}
            <number-input #endRangeMinute
                          [type]="'integer'"
                          [(ngModel)]="timeFields.endDateRange.minutes"
                          [classes]="['time-input']"
                          formControlName="endMinutes"
                          (blur)="checkDateRange('endDateRange', 'end')"
                          (keyup)="setDateRange('endDateRange',
                          endRangeHour.input.nativeElement.value,
                          endRangeMinute.input.nativeElement.value,
                          'end')"
                          [readOnly]="preview || isEmptyRange('end') || isFullDayAllowed() || isHalfDayAllowed()"
                          [disabled]="isAccrualEstimating(currentEvent) || isAccrualPrepareEstimation(currentEvent)">
            </number-input>
            {{'PAYROLL_PREPARE.m' | translate}}
            {{ getRangeDurationLabel(currentEvent.endDateRange, 'end')}}

            <div class="time-of-day" *ngIf="!preview && !isSliderLoaded">
              <div class="day-buttons" [ngClass]="{'greyed-out': isFullDayAllowed() || isEmptyRange('end')}">
                <button class="btn buttons-xs p-x-xs btn-day-part"
                        [ngClass]="{
                        'btn-day-part-active': isMorning('endDateRange'),
                        'greyed-out': isFullDayAllowed() || isEmptyRange('end')}"
                        [disabled]="isFullDayAllowed() || isHalfDayAllowed() || isMorningDisabled('endDateRange')
                        || isEmptyRange('end') || isAccrualEstimating(currentEvent) || isAccrualPrepareEstimation(currentEvent)"
                        (click)="setMorning('endDateRange')">
                  {{'TIME_AND_ATTENDANCE.morning' | translate}}
                </button>
                <button class="btn buttons-xs p-x-xs btn-day-part"
                        [ngClass]="{
                        'btn-day-part-active': isAfternoon('endDateRange'),
                        'greyed-out': isFullDayAllowed() || isEmptyRange('end')}"
                        [disabled]="isFullDayAllowed() || isEmptyRange('end') || isAccrualEstimating(currentEvent) || isAccrualPrepareEstimation(currentEvent)"
                        (click)="setAfternoon('endDateRange')">
                  {{'TIME_AND_ATTENDANCE.afternoon' | translate}}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row" style="margin-bottom: 1rem;"
           *ngIf="currentEvent.parentType === 'repAbsence' && isSingleDay(currentEvent)">
        <div class="col-md-12">
          <div class="form-group">
            {{ 'PAYROLL_PREPARE.duration' | translate }}:
            <number-input #singleRangeHour
                          [type]="'integer'"
                          [(ngModel)]="timeFields.singleDateRange.hours"
                          [classes]="['time-input']"
                          formControlName="singleHours"
                          (blur)="checkDateRange('singleDateRange', 'begin')"
                          (keyup)="setDateRange('singleDateRange',
                          singleRangeHour.input.nativeElement.value,
                          singleRangeMinute.input.nativeElement.value,
                          'begin')"
                          [readOnly]="preview || isEmptyRange('begin') || isFullDayAllowed() || isHalfDayAllowed()
                          || isAccrualEstimating(currentEvent) || isAccrualPrepareEstimation(currentEvent)">
            </number-input>
            {{'PAYROLL_PREPARE.h' | translate}}
            <number-input #singleRangeMinute
                          [type]="'integer'"
                          [(ngModel)]="timeFields.singleDateRange.minutes"
                          [classes]="['time-input']"
                          formControlName="singleMinutes"
                          (blur)="checkDateRange('singleDateRange', 'begin')"
                          (keyup)="setDateRange('singleDateRange',
                          singleRangeHour.input.nativeElement.value,
                          singleRangeMinute.input.nativeElement.value,
                          'begin')"
                          [readOnly]="preview || isEmptyRange('begin') || isFullDayAllowed() || isHalfDayAllowed()
                          || isAccrualEstimating(currentEvent) || isAccrualPrepareEstimation(currentEvent)">
            </number-input>
            {{'PAYROLL_PREPARE.m' | translate}}
            {{ getRangeDurationLabel(currentEvent.singleDateRange, 'begin') }}
            <div class="time-of-day" *ngIf="!preview && !isSliderLoaded">
              <div class="day-buttons" [ngClass]="{'greyed-out': isFullDayAllowed() || isEmptyRange('begin')}">
                <button class="btn p-x-md btn-day-part"
                        [ngClass]="{
                        'btn-day-part-active': isMorning('singleDateRange'),
                        'greyed-out': isFullDayAllowed() || isEmptyRange('begin')}"
                        [disabled]="isFullDayAllowed() || isMorningDisabled('singleDateRange') || isEmptyRange('begin')
                        || isAccrualEstimating(currentEvent) || isAccrualPrepareEstimation(currentEvent)"
                        (click)="setMorning('singleDateRange')">
                  {{'TIME_AND_ATTENDANCE.morning' | translate}}
                </button>
                <button class="btn p-x-md btn-day-part"
                        [ngClass]="{
                        'btn-day-part-active': isAfternoon('singleDateRange'),
                        'greyed-out': isFullDayAllowed() || isEmptyRange('begin')}"
                        [disabled]="isFullDayAllowed() || isAfternoonDisabled('singleDateRange') || isEmptyRange('begin')
                        || isAccrualEstimating(currentEvent) || isAccrualPrepareEstimation(currentEvent)"
                        (click)="setAfternoon('singleDateRange')">
                  {{'TIME_AND_ATTENDANCE.afternoon' | translate}}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ng-container *ngIf="isEss && accrualConfig && currentEvent.isNew && currentEvent.duration">
        <div class="row">
          <div class="col-md-12">
            {{ 'PAYROLL_PREPARE.as_of' | translate:{date: currentEvent.attributes.end} }}
            <span *ngIf="isAccrualOutOfRange(currentEvent)">
              &nbsp;({{'PAYROLL_PREPARE.balance_out_of_range' | translate}})
            </span>
            <span *ngIf="isAccrualConfigNotFound(currentEvent) || isAccrualConfigNotUsable(currentEvent)">
              &nbsp;({{'PAYROLL_PREPARE.balance_config_not_found' | translate}})
            </span>
            <p *ngIf="isAccrualEstimating(currentEvent) || isAccrualPrepareEstimation(currentEvent)"
               class="p-a-md padding text-center">
              <span>{{'PAYROLL_PREPARE.balance_estimating' | translate}}</span>
              <i class="fa fa-light fa-spinner fa-spin"></i>
            </p>
            <gp-table *ngIf="!isAccrualEstimating(currentEvent) && !isAccrualPrepareEstimation(currentEvent)">
              <tbody>
              <tr>
                <td class="text-left">{{'PAYROLL_PREPARE.balance_before' | translate}}:</td>
                <td *ngIf="isAccrualEstimated(currentEvent)" class="text-right">
                  {{currentEvent.duration?.before}} {{accrualConfig.accrual_type_transid | translate}}
                  <span *ngIf="currentEvent.duration?.beforeBeginDate">
                    ({{currentEvent.duration.beforeBeginDate | gpDate: {format: 'MMM-YY'} | titlecase}})
                  </span>
                </td>
                <td *ngIf="!isAccrualEstimated(currentEvent)" class="text-right">&#10006;</td>
              </tr>
              <tr>
                <td class="text-left">{{'PAYROLL_PREPARE.this_balance' | translate}}:</td>
                <td
                  class="text-right">{{currentEvent.duration?.current}} {{accrualConfig.accrual_type_transid | translate}}</td>
              </tr>
              <tr>
                <td class="text-left">{{'PAYROLL_PREPARE.balance_after' | translate}}:</td>
                <td
                  class="text-right">{{currentEvent.duration?.after}} {{accrualConfig.accrual_type_transid | translate}}</td>
              </tr>
              </tbody>
            </gp-table>
          </div>
        </div>
      </ng-container>

      <div class="row" *ngIf="currentEvent.attributes.type">
        <div class="col-md-12">
          <div class="form-group">
            <label>{{'Comment' | translate}}</label>
            <div>
              <textarea class="textarea-control"
                        [ngClass]="{'input-disabled': preview}"
                        name="comment"
                        formControlName="comment"
                        [readOnly]="preview"
                        [(ngModel)]="currentEvent.attributes.comment"
                        rows="5">
              </textarea>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <div class="form-group" *ngIf="currentEvent.parentType === 'repVariable'">
            <label>
              {{ currentEvent?.attributes?.unitTransId
              ? currentEvent.attributes.unitTransId
              : 'PAYROLL_PREPARE.value' | translate }}
              <span class="required">*</span>
            </label>
            <number-input #input
                          [type]="'decimal'"
                          name="value"
                          test-id="decimalValue"
                          [(ngModel)]="currentEvent.attributes.value"
                          [validOnPristine]="true"
                          (ngModelChange)="checkInputValue()"
                          required
                          formControlName="value">
            </number-input>
            <ul class="error-list" [attr.data-hidden]="!isMaximumTime || !isBeginBeforeEnd">
              <li>{{'FORMS.VALIDATORS.exceeding_allowed_value' | translate}}</li>
            </ul>
          </div>
        </div>
      </div>
      <div class="row" style="margin-bottom: 1rem;">
        <gp-generated-simple-form
          [setDefaultTodayForDate]="false"
          [groupZoneDescriptor]="repAbsenceGroupZoneDescriptor"
          [values]="repAbsenceZoneValues"
          [readOnly]="preview">
        </gp-generated-simple-form>
      </div>
    </form>

    <ul class="error-list" [attr.data-hidden]="!canTakeLeaveInPastError || preview">
      <li>{{'PAYROLL_PREPARE.cannot_take_leave_in_past' | translate}}</li>
    </ul>
    <ul class="error-list" [attr.data-hidden]="canTakeLeaveInPastError || canTakeLeave()">
      <li>{{'TIME_AND_ATTENDANCE.accrual_too_small' | translate}}</li>
    </ul>
  </div>
  <div class="gp-modal-footer">

    <div class="btn-bar-wrapper">
      <div class="btn-bar btn-bar-sm btn-bar-align-end">
        <button type="button" class="btn btn-outline-primary p-x-md me-auto"
                *ngIf="!preview && currentEvent?.id"
                (click)="deleteEvent(currentEvent); eventpopup.close()">
          {{ 'FORMS.delete' | translate }}
        </button>
        <button type="button"
                test-id="submitBtn"
                class="btn btn-dark p-x-md"
                *ngIf="!preview"
                (click)="submitForm(eventpopup)"
                [disabled]="!isFormValid() || !canTakeLeave() || canTakeLeaveInPastError || cantSubmitReadOnlyRequired()
            || isAccrualEstimating(currentEvent) || isAccrualPrepareEstimation(currentEvent)">
          {{ (isEss ? 'FORMS.save' : 'EMPLOYEE_FORM.submit') | translate }}
        </button>
        <button type="button"
                test-id="cancelBtn"
                class="btn btn-secondary p-x-md"
                (click)="onClose(eventpopup)">
          {{ preview ? ('FORMS.enclose' | translate) : ('FORMS.cancel' | translate) }}
        </button>
      </div>
    </div>

  </div>
</gp-modal>

<div>
  <div class="m-a" *ngIf="!workCycleIsSpecified && workCycleLoaded && !isLongFuture">
    <gp-message text="ERROR.work_cycle_not_specified" type="danger"></gp-message>
  </div>

  <div class="m-a" *ngIf="isLongFuture">
    <gp-message text="ERROR.contract_begins_far_future" type="danger"></gp-message>
  </div>

  <div *ngIf="!workCycleLoaded" class="padding">
    <i class="fa fa-light fa-spinner fa-spin"></i>
  </div>

  <div *ngIf="workCycleIsSpecified && workCycleLoaded && !isLongFuture">
    <div class="flex">
      <section class="col-xs-11 clear-p-l clear-p-r flex">
        <gp-ui-expandable-box class="col-sm-6 flex" [padding]="'0.5rem'" *ngIf="!isEss && leftReport">
          <div class="gp-box-header">
            <div class="pull-left m-r">
            <span class="w-40 rounded purple">
              <i class="fa-regular fa-calendar-days"></i>
            </span>
            </div>
            <div class="clear">
              <h3>{{ getTranslation({value: leftReport.title, translate: true}, leftReport.values) }}</h3>
              <small>{{ getTranslation({value: leftReport.subtitle, translate: true}, leftReport.values) }}</small>
            </div>
          </div>
          <div class="gp-box-body tOverflow">
            <gp-table>
              <thead gp-table-head>
              <tr role="row">
                <th *ngFor="let column of leftReport.columns">{{ column | translate }}</th>
              </tr>
              </thead>
              <tbody>
              <tr *ngFor="let line of leftReport.lines">
                <td *ngFor="let column of leftReport.columns">
                  {{ getTranslation(line[column], leftReport.values) }}
                </td>
              </tr>
              </tbody>
            </gp-table>
          </div>
        </gp-ui-expandable-box>
        <gp-ui-expandable-box class="col-sm-6 flex counters-report" [padding]="'0.5rem'" *ngIf="isEss">
          <div class="gp-box-header">
            <div class="pull-left m-r">
            <span class="w-40 rounded purple">
              <i class="fa-solid fa-list-check"></i>
            </span>
            </div>
            <div class="clear">
              <h3>{{ (pendingRequests.length ? 'LEAVE_REQUEST.count_pending_requests' : 'LEAVE_REQUEST.no_pending_requests')
                | translate:{count: pendingRequests.length || 0} }}</h3>
              <small *ngIf="pendingRequests.length">
                {{ 'LEAVE_REQUEST.latest_pending_request' | translate:{date: (pendingRequests[0]?.dateCreated | gpDate:{timeAgo: true})} }}
              </small>
            </div>
          </div>

          <div class="gp-box-body">

            <div class="padding text-center" *ngIf="pendingLoading">
              <i class="fa fa-light fa-spinner fa-spin"></i>
            </div>

            <div class="padding" *ngIf="!pendingLoading && !pendingRequests.length">
              <gp-message text="LEAVE_REQUEST.no_pending_requests" type="info"></gp-message>
            </div>

            <table class="table box-body-table">
              <tr *ngFor="let item of pendingRequests">
                <td>
                  <div>
                    {{item.transId | translate}}
                    <ng-container *ngIf="item.onCancellation">
                      ({{'LEAVE_REQUEST.cancellation' | translate}})
                    </ng-container>
                  </div>
                  <div>{{item.begin}} &mdash; {{item.end}}</div>
                  <div class="small pull-left">
                    {{'LEAVE_REQUEST.pending_from' | translate:{name: item.recipientName} }}
                  </div>
                  <div class="small pull-right">{{ item.dateCreated | gpDate:{timeAgo: true} }}</div>
                </td>
              </tr>
            </table>
          </div>
        </gp-ui-expandable-box>
        <gp-ui-expandable-box class="col-sm-6 flex" [padding]="'0.5rem'" *ngIf="rightReport">
          <div class="gp-box-header">
            <div class="pull-left m-r">
            <span class="w-40 rounded warn cBlack">
              <i class="fa-regular fa-calendar-days"></i>
            </span>
            </div>
            <div class="clear">
              <h3>{{ getTranslation({value: rightReport.title, translate: true}, rightReport.values) }}</h3>
              <small>{{ getTranslation({value: rightReport.subtitle, translate: true}, rightReport.values) }}</small>
            </div>
          </div>
          <div class="gp-box-body tOverflow">
            <gp-table>
              <thead gp-table-head>
              <tr role="row">
                <th *ngFor="let column of rightReport.columns">{{ column | translate }}</th>
              </tr>
              </thead>
              <tbody>
              <!-- <tr *ngIf="reportL.isLoading === true">
                 <td colspan="10" class="text-center p-t-lg p-b-lg">
                   <i class="fa fa-light fa-spinner fa-spin"></i>
                 </td>
               </tr>-->
              <!--<tr *ngIf="reportL.isLoading === false && reportL.lines?.length === 0">
                <td colspan="10" class="text-center p-t-lg p-b-lg">
                  {{ 'PAYROLL_PREPARE.no_reports_found' | translate }}
                </td>
              </tr>-->
              <tr *ngFor="let line of rightReport.lines">
                <td *ngFor="let column of rightReport.columns">
                  {{ getTranslation(line[column], rightReport.values) }}
                </td>
              </tr>
              </tbody>
            </gp-table>
          </div>
        </gp-ui-expandable-box>

      </section>

      <section class="col-lg-1 btn-group no-padding m-a-sm">
        <div class="col-sm-12 m-b-sm no-padding">
          <button class="btn btn-fw white btn-block cs-btn reset-min-width"
                  test-id="weekView"
                  id="weekview"
                  (click)="changeView('week')"
                  [class.active]="view === 'week'">{{ 'PAYROLL_PREPARE.week' | translate }}
          </button>
        </div>
        <div class="col-sm-12 no-padding">
          <button class="btn btn-fw white btn-block cs-btn reset-min-width"
                  test-id="monthView"
                  id="monthView"
                  (click)="changeView('month')"
                  [class.active]="view === 'month'">{{ 'PAYROLL_PREPARE.month' | translate }}
          </button>
        </div>
      </section>
    </div>
    <div class="fullcalendar fc fc-ltr fc-unthemed light shadow">
      <div class="fc-toolbar year-tollbar" test-id="yearToolbar">
        <div class="fc-left">
          <button type="button"
                  test-id="time-and-attendance-dec-year-button"
                  class="fc-prev-button fc-button fc-state-default fc-corner-left fc-corner-right"
                  (click)="decrementYear()">
            <span class="fc-icon fc-icon-left-single-arrow direction-ltr"></span>
          </button>
        </div>
        <div class="fc-right">
          <button type="button"
                  test-id="time-and-attendance-inc-year-button"
                  class="fc-next-button fc-button fc-state-default fc-corner-left fc-corner-right"
                  (click)="incrementYear()">
            <span class="fc-icon fc-icon-right-single-arrow direction-ltr"></span>
          </button>
        </div>
        <div class="fc-center">
          <h2>{{ viewDate | date:'yyyy' }}</h2>
        </div>
        <div class="fc-clear"></div>
      </div>
      <div class="fc-toolbar" test-id="monthToolbar">
        <div class="fc-left">
          <button type="button"
                  test-id="time-and-attendance-dec-month-button"
                  class="fc-prev-button fc-button fc-state-default fc-corner-left fc-corner-right"
                  (click)="decrement()">
            <span class="fc-icon fc-icon-left-single-arrow direction-ltr"></span>
          </button>
        </div>
        <div class="fc-right">
          <button type="button"
                  test-id="time-and-attendance-inc-month-button"
                  class="fc-next-button fc-button fc-state-default fc-corner-left fc-corner-right"
                  (click)="increment()">
            <span class="fc-icon fc-icon-right-single-arrow direction-ltr"></span>
          </button>
        </div>
        <div class="fc-center">
          <h2 test-id="nameMonth">{{ viewDate | gpDateRange:view }}</h2>
        </div>
        <div class="fc-clear"></div>
      </div>
      <div class="fc-view-container" style="">
        <div *ngIf="loading" class="padding text-center">
          <i class="fa fa-light fa-spinner fa-spin"></i>
        </div>
        <gp-calendar-month-view
          *ngIf="!loading && view === 'month'"
          [viewDate]="viewDate"
          [workcycle]="workcycle"
          [eventTypesByFamilyTransId]="types"
          [eventTypes]="eventTypes"
          (eventClicked)="eventClicked($event)"
          (eventChanged)="eventChanged($event)"
          [absences]="absences"
          [presences]="presences"
          [isReadOnly]="isReadOnly"
          [isEss]="isEss">
        </gp-calendar-month-view>
        <gp-calendar-week-view
          *ngIf="!loading && view === 'week'"
          [viewDate]="viewDate"
          [workcycle]="workcycle"
          [workedHours]="workedHours"
          [eventTypesByFamilyTransId]="types"
          [eventTypes]="eventTypes"
          (eventClicked)="eventClicked($event)"
          (eventChanged)="eventChanged($event)"
          [absences]="absences"
          [presences]="presences"
          [isReadOnly]="isReadOnly"
          [isEss]="isEss">
        </gp-calendar-week-view>
      </div>
    </div>
  </div>

</div>
